<div layout layout-full-width padding-tb-small-xxx padding-lr class="container">
  <div class="label" padding-top-small-xx>
    {{ name() }}
  </div>
  <div class="value" layout-horizontal overflow-hidden padding-tb-small-xxx>
    <div layout-full-width>
      <div class="row" layout-horizontal layout-align-items-center>
        <ng-container *ngTemplateOutlet="fieldDisplayTpl()!" />
      </div>
    </div>
  </div>
</div>
